import * as Yup from "utils/yup"
import {
  getEmailMessage,
  getEmailDomainPartMaxMessage,
  getEmailLocalPartMaxMessage,
  getEmailTotalMaxMessage,
  getValidEmail,
} from "components/Common/validationMessages"

export const EMAIL_LOCAL_MAX_LENGTH = 64
export const EMAIL_DOMAIN_MAX_LENGTH = 255
export const EMAIL_TOTAL_MAX_LENGTH = 320

export const EMAIL_FORMAT_REGEX =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const parseEmailParts = email => {
  const normalized = String(email || "").trim()
  const atIndex = normalized.lastIndexOf("@")
  if (atIndex <= 0 || atIndex === normalized.length - 1) {
    return null
  }
  return {
    local: normalized.slice(0, atIndex),
    domain: normalized.slice(atIndex + 1),
    full: normalized,
  }
}

export const getEmailValidationErrorMessage = code => {
  switch (code) {
    case "local":
      return getEmailLocalPartMaxMessage()
    case "domain":
      return getEmailDomainPartMaxMessage()
    case "total":
      return getEmailTotalMaxMessage()
    case "format":
    default:
      return getValidEmail()
  }
}

export const validateEmailAddress = email => {
  const parts = parseEmailParts(email)
  if (!parts) {
    return { valid: false, code: "format" }
  }
  if (parts.full.length > EMAIL_TOTAL_MAX_LENGTH) {
    return { valid: false, code: "total" }
  }
  if (parts.local.length > EMAIL_LOCAL_MAX_LENGTH) {
    return { valid: false, code: "local" }
  }
  if (parts.domain.length > EMAIL_DOMAIN_MAX_LENGTH) {
    return { valid: false, code: "domain" }
  }
  if (!EMAIL_FORMAT_REGEX.test(parts.full)) {
    return { valid: false, code: "format" }
  }
  return { valid: true }
}

export const buildEmailYupSchema = ({ required = true } = {}) => {
  let schema = Yup.string()
    .trim()
    .max(EMAIL_TOTAL_MAX_LENGTH, getEmailTotalMaxMessage())
    .test("valid-email-rfc5321", function validateEmail(value) {
      if (!value || !String(value).trim()) {
        if (required) {
          return this.createError({ message: getEmailMessage() })
        }
        return true
      }

      const result = validateEmailAddress(value)
      if (result.valid) {
        return true
      }

      return this.createError({
        message: getEmailValidationErrorMessage(result.code),
      })
    })

  if (required) {
    schema = schema.required(getEmailMessage())
  }

  return schema
}

export const buildOptionalEmailYupSchema = () =>
  buildEmailYupSchema({ required: false })
